<template>
  <div class="contain">
    <div class="box flex-direction-row" @click="goZxDetail">
      <img
        v-if="cardData.courseImg"
        :src="cardData.courseImg"
        class="imgsize"
      />
      <img
        v-else
        src="@/assets/images/model-com/fm.png"
        class="imgsize"
        alt=""
      />
      <div class="flex-direction-column title-box">
        <div class="title text-ellipsis">
          {{ cardData.courseName }}
        </div>
        <!-- <div class="sub-title text-ellipsis-3" >
          {{ cardData.courseDesp }}
        </div> -->
        <div class="timezw">
          <div class="button">
            <p>立即观看</p>
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState("new_user", ["isLogin", "mobileNo"]),
  },
  props: {
    cardData: {
      type: Object,
      default: () => ({}), // 默认启用一个空对象
    },
  },
  methods: {
    goZxDetail() {
      if (this.isLogin === false) {
        this.$toast("请先登录享权益");
        return;
      }
      this.$router.push({
        name: "playervideo",
        params: { data: this.cardData },
      });
    },
  },
  components: {},
  mounted() {},
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  padding: 6px 14px;
  box-sizing: border-box;
  background-color: #fff;
  .imgsize {
    width: 139px;
    height: 83px;
    border-radius: 15px;
    overflow: hidden;
  }
}
.timezw {
  height: 30px;
}

.title-box {
  width: 155px;
  height: 84px;
  justify-content: space-between;
  margin-left: 11px;

  .title {
    width: 185px;
    font-weight: bold;
    font-size: 15px;
    color: #333333;
    line-height: 17px;
  }

  .sub-title {
    width: 189px;
    font-weight: 500;
    font-size: 10px;
    color: #b9b4b4;
    line-height: 12px;
    text-align: left;
  }
}
.text-ellipsis-3 {
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.timezw {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.button {
  font-size: 10px;
  color: white;
  padding: 5px 10px;
  border-radius: 30px;
  text-align: center;
  align-items: center;
  display: flex;
  background-color: #ff7b26;
}
</style>
